import React from 'react';
import { css, cx } from '@emotion/css';
import { theme, IconDropdownExpand, IconDropdownCollapse, IconClose, useLocalizationContext, useThemeContext, getThemeColor, } from '@contrast-security-inc/design-system-foundations';
import * as messages from './translations';
import { Adornment } from '../InputModules/Adornment';
import { Stack } from '@contrast-security-inc/design-system-layouts';
const commonActionButtonStyles = (selectedTheme) => css `
  align-items: center;
  align-self: center;
  background-color: ${getThemeColor(selectedTheme, { light: theme.color.white, dark: theme.color.black })};
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 6px 12px 6px 0;

  &:focus-visible {
    outline: none;
  }

  &:hover svg {
    fill: ${theme.color.turquoise70};
  }
`;
const clearSelectionButtonStyles = css `
  padding: 6px 2px;
`;
const iconColor = (selectedTheme) => (selectedTheme === 'dark' ? 'white' : 'black');
export const ListboxActions = ({ clearSelection = () => '', getToggleButtonProps = () => ({}), isDisabled, isMultiSelect = false, isOpen, selectedItem, selectedItems = [], showClearAllIcon = false, testId, }) => {
    const { selectedTheme } = useThemeContext();
    const { formatMessage } = useLocalizationContext();
    if (isDisabled) {
        return null;
    }
    const selectedItemExists = selectedItem || selectedItems.length > 0;
    const showClearAllSelection = isMultiSelect ? showClearAllIcon : true;
    const showClearIcon = selectedItemExists && showClearAllSelection;
    return (React.createElement(Stack, { alignItems: "center", spacing: "0px" },
        showClearIcon && (React.createElement(Adornment, { additionalStyles: cx(commonActionButtonStyles(selectedTheme), clearSelectionButtonStyles), position: 'start', render: React.createElement("button", { "aria-label": formatMessage(messages, 'clearSelection'), "data-clear-input": true, onClick: () => {
                    showClearIcon && clearSelection();
                }, type: "button" },
                React.createElement(IconClose, { size: "sm", color: iconColor(selectedTheme) })), testId: testId })),
        React.createElement(Adornment, { additionalStyles: commonActionButtonStyles(selectedTheme), position: 'end', render: React.createElement("button", { tabIndex: -1, type: "button", ...getToggleButtonProps(), "aria-label": formatMessage(messages, 'toggleSelectMenu') }, isOpen ? (React.createElement(IconDropdownCollapse, { size: "md", color: iconColor(selectedTheme) })) : (React.createElement(IconDropdownExpand, { size: "md", color: iconColor(selectedTheme) }))), testId: testId })));
};
